import React from 'react'
import {Avatar, IconButton, Menu, MenuItem, Typography} from '@mui/material'
import {useAuth} from '../auth/auth'
import {useNavigate} from 'react-router-dom'

function NavBar() {
    const {logout, getName, getEmail} = useAuth()
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const navigate = useNavigate()

    const handleClickLogo = (_event: React.MouseEvent<HTMLElement>) => {
        navigate('/')
    }

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleLogout = () => {
        logout()
        handleClose()
    }

    const getInitials = () => {
        const name = getName()
        if (getName()) {
            const names = name.split(' ')
            const initials = names.map(n => n.charAt(0).toUpperCase()).join('')
            return initials
        }
        return ''
    }

    return (
        <>
            <header
                className="tg-jordy-blue-bg px-4 lg:px-6 py-6 text-sm p-4 sticky top-0 flex items-center justify-between">
                <img
                    alt="HTL Logo"
                    src="/logo.svg"
                    className="w-60 relative top-px"
                    onClick={handleClickLogo}
                />
                <IconButton onClick={handleClick}>
                    <Avatar>{getInitials()}</Avatar>
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem disabled>
                        <Typography variant="body1">{getEmail()}</Typography>
                    </MenuItem>
                    <MenuItem onClick={() => {
                        navigate('/')
                        handleClose()
                    }}>
                        Home
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>
                        Logout
                    </MenuItem>
                </Menu>
            </header>
        </>
    )
}

export default NavBar
